import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {AidantService} from '../../_services';
import {Patient, User} from '../../_models';
import {first} from 'rxjs/operators';
import {getUser} from '../../../assets/utils.js';

@Component({
  selector: 'app-create-abeille-aidant',
  templateUrl: './create-abeille-aidant.component.html',
  styleUrls: ['./create-abeille-aidant.component.scss']
})
export class CreateAbeilleAidantComponent {

    @Output() refreshEvent = new EventEmitter<string>();

    show = true;
    user: User;
    errors = [];
    uploading = false;

    aidantForm = new FormGroup({
        key: new FormControl(''),
        birthday: new FormControl(''),
    });

    constructor(private aidantService: AidantService) {
        this.user = getUser();
    }

    checkAidantInfos() {

        this.errors = [];
        let isOK = true;

        if (!this.aidantForm.value.key) {
          this.errors[`key`] = true;
          isOK = false;
        }
        if (!this.aidantForm.value.birthday) {
          this.errors[`birthday`] = true;
          isOK = false;
        }

        if (!isOK) {
          return;
        }

    }

    onSubmit() {

        let birthdayRaw = this.aidantForm.value.birthday;
        birthdayRaw = birthdayRaw.split('/');
        let birthday = birthdayRaw[2] + '-' + birthdayRaw[1] + '-' + birthdayRaw[0];

        this.uploading = true;

        this.aidantService.getByKeyAndBirthday(this.aidantForm.value.key, birthday).pipe(first()).subscribe(result => {

            this.uploading = false;

            let res = result as any[];
            if (res.length && res[0].patient) {
                this.assignUserAsAidant(res[0]);
            } else {
                alert("Impossible de trouver l'enfant correspondant.\nLes infos rensignées sont erronées ou vous l'avez déjà ajouté comme aidant.")
            }

        });

    }

    assignUserAsAidant(aidant: any) {

        this.aidantService.assignUserAsAidant(this.user.id, aidant.id).pipe(first()).subscribe(result => {
            this.aidantForm.reset();
            this.refreshEvent.next();
        });

    }

}
